/*
  Collection parent-group dedupe (cross-page).

  The collection grid picks the lowest-priced member of each
  custom.product_parent_group to represent that group, but Liquid can only
  see one paginated page at a time, so a group whose members straddle a page
  boundary can render a second card when the next page is appended by
  "Load more" / infinite scroll.

  This removes those late duplicates on the client. Server-rendered page 1 is
  already correct; we only prune cards added after initial load.
*/
(function () {
  'use strict';

  var GRID = '.collection__products';
  var CARD = '.product-item[data-parent-group]';

  function groupOf(card) {
    return (card.getAttribute('data-parent-group') || '').trim().toLowerCase();
  }

  function dedupe(grid) {
    var seen = Object.create(null);
    var cards = grid.querySelectorAll(CARD);

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var group = groupOf(card);
      if (!group) continue;

      if (seen[group]) {
        // Keep the first occurrence; it is the cheapest one Liquid selected.
        var item = card.closest('[data-input-item]') || card;
        if (item.parentNode) item.parentNode.removeChild(item);
      } else {
        seen[group] = true;
      }
    }
  }

  function watch(grid) {
    if (grid.dataset.groupDedupeBound === 'true') return;
    grid.dataset.groupDedupeBound = 'true';

    dedupe(grid);

    var timer = null;
    var observer = new MutationObserver(function () {
      // Let the theme finish inserting the whole batch before pruning.
      // A timeout (not rAF) so this still runs in a backgrounded tab.
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        timer = null;
        dedupe(grid);
      }, 50);
    });

    observer.observe(grid, { childList: true, subtree: true });
  }

  function init() {
    var grids = document.querySelectorAll(GRID);
    for (var i = 0; i < grids.length; i++) watch(grids[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The grid is replaced wholesale when filters/sort change.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('theme:filters:updated', init);
})();
